import sieviApi from "@/api/sieviApi"
// export const myAction = async ( { commit } ) => {

// }

export const obtainPeriod = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/periodos`)
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createPeriod = async ( _, { form } ) => {
    const periodForm = {
        nombre: form.name,
        fechaInicial: form.initialDate.getFullYear()+"-"+(form.initialDate.getMonth()+1)+"-"+form.initialDate.getDate(),
        fechaFinal: form.finalDate.getFullYear()+"-"+(form.finalDate.getMonth()+1)+"-"+form.finalDate.getDate(),
        campus_id: form.campusId,
        semanas: form.numWeeks
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/periodos`, periodForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const showPeriod = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/periodos/${id}`)
        if (data.ok) {
            commit('setCurrentPeriod', data.periodo)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const editPeriod = async ( _, { form } ) => {
    const periodForm = {
        nombre: form.name,
        fechaInicial: form.initialDate.getFullYear()+"-"+(form.initialDate.getMonth()+1)+"-"+form.initialDate.getDate(),
        fechaFinal: form.finalDate.getFullYear()+"-"+(form.finalDate.getMonth()+1)+"-"+form.finalDate.getDate(),
        campus_id: form.campusId
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/periodos/${form.id}`, periodForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deletePeriod = async ( _, idPeriod ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.delete(`/api/administrador/periodos/${idPeriod}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const activatePeriod = async ( { commit }, idPeriod ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/periodos/activar/${idPeriod}`)
        if (data.ok) {
            commit('activePeriod', data.periodo)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deactivatePeriod = async ( { commit }, idPeriod ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/periodos/desactivar/${idPeriod}`)
        if (data.ok) {
            commit('deactivatePeriod', data.periodo)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainWeeks = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/semanas/${id}`)
        if (data.ok) {
            commit('setWeeks', data.semanas)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const addWeek = async ( _, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/semanas`, { periodo_id: id})
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const removeWeek = async ( _, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.delete(`/api/administrador/semanas/${id}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const editWeek = async ( { commit }, { form } ) => {
    const weekForm = {
        nombre: form.name,
        fechaInicial: (form.initialDate == null) ? null : form.initialDate.getFullYear()+"-"+(form.initialDate.getMonth()+1)+"-"+form.initialDate.getDate(),
        fechaFinal:  (form.finalDate == null) ? null : form.finalDate.getFullYear()+"-"+(form.finalDate.getMonth()+1)+"-"+form.finalDate.getDate()
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/semanas/${form.id}`, weekForm)
        if (data.ok) {
            commit('editWeek', data.semana)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const editSpecialWeek = async ( { commit }, { form } ) => {
    const weekForm = {
        nombre: form.nombre,
        fechaInicial: (form.fechaInicial == null) ? null : form.fechaInicial.getFullYear()+"-"+(form.fechaInicial.getMonth()+1)+"-"+form.fechaInicial.getDate(),
        fechaFinal:  (form.fechaFinal == null) ? null : form.fechaFinal.getFullYear()+"-"+(form.fechaFinal.getMonth()+1)+"-"+form.fechaFinal.getDate(),
        semanaId: form.id,
        contractPeriodId: form.contractPeriodId
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/semanas/especiales/${form.contractId}`, weekForm)
        if (data.ok) {
            commit('editSpecialWeeks', data.semana)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const openEdit = async ( { commit }, id ) => {
    try {
        commit('openEdit', id)

        return { ok: true, message: 'Se abrio el panel de edición satisfactoriamente'}
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const closeEdit = async ( { commit }, { id, form } ) => {
    try {
        commit('closeEdit', { id, form })

        return { ok: true, message: 'Se cerro el panel de edición satisfactoriamente'}
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const closeEditSpecialWeeks = async( { commit }, { contractPeriodId, weekId, form } ) => {
    try {
        commit('closeEditSpecialWeeks', { contractPeriodId, weekId, form })

        return { ok: true, message: 'Se cerro el panel de edición satisfactoriamente'}
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainPeriodsDocente = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/periodos/${id}`)
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainPeriodsResponsable = async ( { commit }, { id, campusId, hfsId, programId, teacherId, contractId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/periodos/${id}/${campusId}/${hfsId}/${programId}/${teacherId}/${contractId}`)
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            commit('setPeriod', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainAllPeriod = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/periodos`)
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainAllPeriodAuditor = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/periodos`)
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainPeriodsAuditor = async ( { commit }, { campusId, programId, teacherId, contractId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/periodos/${campusId}/${programId}/${teacherId}/${contractId}`)
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            commit('setPeriod', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainPeriodsAuditorReports = async ( { commit }, { campusId, programId, hfsId } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/auditor/reportes/periodos`, { campus: campusId, programs: programId, hfs: hfsId })
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            commit('setPeriod', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainPeriodsResponsableReports = async ( { commit }, { id, campusId, programId, hfsId } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/responsable/reportes/periodos`, { id: id, campus: campusId, programs: programId, hfs: hfsId })
        if (data.ok) {
            commit('setPeriod', data.periodos)
            return { ok: true, message: data.message }
        } else {
            commit('setPeriod', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainWeeksAuditor = async ( { commit }, periodoId ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/reportes/semanas/${periodoId}`)
        if (data.ok) {
            commit('setWeeks', data.semanas)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainWeeksResponsable = async ( { commit }, periodoId ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/reportes/semanas/${periodoId}`)
        if (data.ok) {
            commit('setWeeks', data.semanas)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainSpecialWeeks = async ( { commit }, contractId ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/semanas/especiales/${contractId}`);
        if (data.ok) {
            commit('setSpecialWeeks', data.periodos)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const openEditSpecialWeeks = async ( { commit }, { contractPeriodId, weekId } ) => {
    try {
        commit('openEditSpecialWeeks', { contractPeriodId, weekId })

        return { ok: true, message: 'Se abrio el panel de edición satisfactoriamente'}
    } catch (error) {
        return { ok: false, message: error }
    }
}